export default {
  data: () => ({}),
  methods: {
    // Função que pega as primeiras letras da string (ou das duas primeiras palavras da string, se tiver mais de uma palavra)
    // Usado para montar o avatar nas telas -> Team, PTaskExpand, PChat
    getFirstLetters (text) {
      /**
       * A próxima linha usa 'text.replace' para substituir todos os espaços da string por um só (caso a string tenha múltiplos
       * espaços: EX.: 'Equipe      de      desenvolvimento') e logo em seguida usa o método split para separar as palavras
       * pelo espaço. Utilizando o exemplo acima, o resultado do split retorna um array assim: ['Equipe', 'de', 'desenvolvimento']
       */
      let textSplit = String(text.replace(/\s+/g, ' ')).toUpperCase().split(' ')
      let initials = ''
      // A variável 'remove' é somente a declaração de um array com todas as preposições que devemos retirar para montar o avatar
      let remove = ['DE', 'DO', 'DA', 'DOS', 'DAS', 'EM', 'NA', 'NO', 'E', 'A', 'O', 'AS', 'OS', '-', '=']
      if (textSplit.length === 1) {
        // Se o array retornado tiver somente uma posição, ou seja, somente uma palavra na string, concatenamos as
        // duas primeiras letras da palavra para montar o avatar.
        initials = textSplit[0].charAt(0) + textSplit[0].charAt(1).toLowerCase()
      } else {
        // Se não: fazemos um loop procurando as preposições declaradas acima
        for (let i = 0; i < remove.length; i++) {
          let index = null
          index = textSplit.indexOf(remove[i])
          if (index !== -1) {
            // se encontrar: remove da string e monta o avatar com a primeira letra das duas primeiras palavras e quebra o loop
            textSplit.splice(index, 1)
            initials = textSplit[0].charAt(0) + (textSplit[1] ? textSplit[1].charAt(0) : textSplit[0].charAt(1).toLowerCase())
            break
          } else {
            // se não: somente monta o avatar com a primeira letra das duas primeiras palavras
            initials = textSplit[0].charAt(0) + textSplit[1].charAt(0)
          }
        }
      }
      return initials
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/general.js